import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Plus } from '@opendate-app/setlist';
import GeneralAdmissionHoldsTable from './GeneralAdmissionHoldsTable';
import GeneralAdmissionHoldModal from './GeneralAdmissionHoldModal';

const GeneralAdmissionHolds = ({
  title = 'Holds',
  description = 'Create and manage holds for this event.',
  csrfToken,
  confirm,
  ticketTypes = [],
  addOns = [],
  generalAdmissionHolds = [],
  fetchGeneralAdmissionHolds,
  createGeneralAdmissionHold,
  updateGeneralAdmissionHold,
  deleteGeneralAdmissionHold,
  reloadTicketTypes
}) => {
  const [showModal, setShowModal] = useState(false);
  const [editingHold, setEditingHold] = useState(null);

  useEffect(() => {
    if (confirm?.id && fetchGeneralAdmissionHolds) {
      fetchGeneralAdmissionHolds(csrfToken, confirm.id);
    }
  }, [confirm?.id, csrfToken, fetchGeneralAdmissionHolds]);

  const handleCreate = (payload) => {
    return createGeneralAdmissionHold(csrfToken, confirm.id, payload);
  };

  const handleUpdate = (payload) => {
    return updateGeneralAdmissionHold(csrfToken, { id: editingHold.id, ...payload });
  };

  const handleDelete = (hold) => {
    return deleteGeneralAdmissionHold(csrfToken, hold);
  };

  const gaTicketTypes = (ticketTypes || []).filter(tt => !tt.seating_chart_category_key);

  return (
    <div>
      <div className="my-3 d-flex flex-column flex-md-row justify-content-between align-items-md-start" style={{ gap: 12 }}>
        <div>
          <div style={{ fontSize: '18px', fontWeight: 600, color: 'var(--sl-text-primary)' }}>{title}</div>
          <div style={{ fontSize: '14px', color: 'var(--sl-text-tertiary)' }}>{description}</div>
        </div>
        <Button
          icon={Plus}
          onClick={() => {
            setEditingHold(null);
            setShowModal(true);
          }}
        >
          Add Hold
        </Button>
      </div>

      <GeneralAdmissionHoldsTable
        holds={generalAdmissionHolds}
        onEdit={(hold) => {
          setEditingHold(hold);
          setShowModal(true);
        }}
        onDelete={handleDelete}
      />

      <GeneralAdmissionHoldModal
        open={showModal}
        onClose={() => { 
          setEditingHold(null); 
          setShowModal(false); 
        }}
        title={editingHold ? 'Edit Hold' : 'Add Hold'}
        initialHold={editingHold}
        ticketTypes={gaTicketTypes}
        addOns={addOns}
        onSubmit={editingHold ? handleUpdate : handleCreate}
      />
    </div>
  );
};

GeneralAdmissionHolds.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  confirm: PropTypes.object.isRequired,
  ticketTypes: PropTypes.array,
  addOns: PropTypes.array,
  generalAdmissionHolds: PropTypes.array,
  fetchGeneralAdmissionHolds: PropTypes.func,
  createGeneralAdmissionHold: PropTypes.func,
  updateGeneralAdmissionHold: PropTypes.func,
  deleteGeneralAdmissionHold: PropTypes.func,
  reloadTicketTypes: PropTypes.func
};

export default GeneralAdmissionHolds;
